import MuiIconButton, { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';

export const IconButton = (props: MuiIconButtonProps): JSX.Element => {
  return <MuiIconButton {...props} />;
};

export default IconButton;
